export default function TrustBar() {
  const stats = [
    { value: '10 000+', label: 'Produktów w bazie' },
    { value: '50+', label: 'Przewodników' },
    { value: '14', label: 'Kategorii produktów' },
  ];

  return (
    <section className="py-8 md:py-10 bg-background-50 border-b border-background-200/50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-3 gap-4 md:gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <p className="font-heading text-2xl md:text-4xl font-bold text-primary-600 mb-1">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-foreground-600">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}